'use client'
import { useRouter, useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { CategoryMenuBlock as CategoryMenuBlockTypes } from '@/payload-types'

interface Category {
  id: string
  category: string
}

export const CategoryMenuBlockClient: React.FC<CategoryMenuBlockTypes> = (props) => {
  const { title, displayAll, selectedCategories } = props
  const [categories, setCategories] = useState<Category[]>([])
  const [loading, setLoading] = useState(true)

  const router = useRouter()
  const searchParams = useSearchParams()
  const currentCategory = searchParams.get('category')

  const handleCategoryChange = (catName: string | null) => {
    const params = new URLSearchParams(window.location.search)

    if (catName) {
      params.set('category', catName)
    } else {
      params.delete('category')
    }

    router.push(`?${params.toString()}`, { scroll: false })
  }

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true)
      try {
        if (displayAll) {
          // Récupération de toutes les catégories
          const res = await fetch(
            '',
            //`/api/categories?where[tenant.domain][equals]=${tenant.domain}&limit=100`,
          )
          const data = await res.json()
          setCategories(data.docs.reverse() || [])
        }
      } catch (error) {
        console.error('Erreur CategoryMenu:', error)
      }
      setLoading(false)
    }

    fetchCategories()
  }, [displayAll, selectedCategories])

  if (loading && categories.length === 0) {
    return (
      <div>
        <svg className="mr-3 size-5 animate-spin" viewBox="0 0 24 24"></svg>
      </div>
    )
  }

  return (
    <>
      {title && <h1 className="text-[#FB7303] text-2xl font-bold mb-2">{title}</h1>}
      <nav className="flex flex-col gap-4 mb-8">
        {/* Bouton réinitialisation */}
        <button
          onClick={() => handleCategoryChange(null)}
          className={`px-3 py-4 lg:pl-8 font-bold rounded hover:cursor-pointer text-left ${!currentCategory ? 'bg-[#FB7303] text-white' : 'bg-[#FFF1E5]'}`}
        >
          Tous
        </button>

        {categories.map((cat, index) => (
          <button
            key={index}
            onClick={() => handleCategoryChange(cat.category)}
            className={`px-3 py-4 lg:pl-8 rounded font-bold hover:cursor-pointer text-left ${
              currentCategory === cat.category ? 'bg-[#FB7303] text-white' : 'bg-[#FFF1E5]'
            }`}
          >
            {cat.category}
          </button>
        ))}
      </nav>
    </>
  )
}
